import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { getB2bScheduleUrl, updateB2bMeetingStatusUrl, removeB2bMeetingUrl, addB2bPersonalNotesUrl, headers, GET_B2B_SCHEDULE, UPDATE_B2B_MEETING_STATUS } from "../../../utils/constants";


export const getB2bScheduleList_action = (Registration, TypeID,) => async (dispatch) => {
    console.log(JSON.parse(sessionStorage.getItem('loginDataSS')), '.........................................')
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            RegistrationID: Registration,
            // ScheduleTypeID: ScheduleTypeID,
            TypeID: TypeID
        }
        console.log("getVisitorDashboard_action Action------->", params)

        const res = await axiosGet(getB2bScheduleUrl, params, headers)

        dispatch({
            type: GET_B2B_SCHEDULE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const removeB2bMeeting_action = (B2BMeetingID) => async (dispatch) => {
    console.log(JSON.parse(sessionStorage.getItem('loginDataSS')), '.........................................')
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            B2BMeetingID: B2BMeetingID,
            // ScheduleTypeID: ScheduleTypeID,
            // TypeID: TypeID
        }
        console.log("getVisitorDashboard_action Action------->", params)

        const res = await axiosGet(removeB2bMeetingUrl, params, headers)

        dispatch({
            type: GET_B2B_SCHEDULE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateB2bStatus_action = (B2BMeetingID, B2BStatusID, RejectedRemark) => async (dispatch) => {
    console.log(JSON.parse(sessionStorage.getItem('loginDataSS')), '.........................................')
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            B2BMeetingID: B2BMeetingID,
            // ScheduleTypeID: ScheduleTypeID,
            B2BStatusID: B2BStatusID,
            RejectedRemark: RejectedRemark,

        }
        console.log("getVisitorDashboard_action Action------->", params)

        const res = await axiosPost(updateB2bMeetingStatusUrl, params, headers)

        dispatch({
            type: UPDATE_B2B_MEETING_STATUS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const addB2bPersonalNotes_action = (ArrangementType,
    TypeID,
    RegistrationID,
    ReferenceID,
    PersonalNotes) => async (dispatch) => {
        console.log(JSON.parse(sessionStorage.getItem('loginDataSS')), '.........................................')
        try {
            const params = {
                ArrangementType: ArrangementType,
                TypeID: TypeID,
                RegistrationID: RegistrationID,
                // ScheduleTypeID: ScheduleTypeID,
                ReferenceID: ReferenceID,
                PersonalNotes: PersonalNotes,

            }
            console.log("getVisitorDashboard_action Action------->", params)

            const res = await axiosPost(addB2bPersonalNotesUrl, params, headers)

            dispatch({
                type: UPDATE_B2B_MEETING_STATUS,
                payload: res,
            });
            return Promise.resolve(res)
        } catch (error) {
            return Promise.reject(error)
        }
    }